import React, { memo } from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
import parse from 'html-react-parser';
import {decode} from 'he';

/* Components */
import HbCollapsingTextView from '../../../components/Text/collapsing/HbCollapsingTextView';
import SeoContentQuestions from './questions/SeoContentQuestions';

/* Constants */
import {SEO_CONTENT_VIEW_TYPES} from './SeoContentConstants';
import {SEO_PARAGRAPH_ELEMENT_ID_AT_PAGE_TOP} from '../../../modules/seo/seoConstants';

import s from './seo-content.scss';

const SeoContent = memo(({
  viewType = SEO_CONTENT_VIEW_TYPES.DEFAULT,
  h2Title,
  textContent,
  isCollapsingEnabled,
  isInitiallyCollapsed,
  questions,
  questionsEnabled = true,
  className = '',
  renderSeoContent = true
}) => {
  if (!textContent) {
    return null
  }

  if (!renderSeoContent) {
    return null
  }

  const decodedContent = decode(textContent)

  return (
    <section
      id={SEO_PARAGRAPH_ELEMENT_ID_AT_PAGE_TOP}
      className={cx(s.root, s.contentWrapper, className, s[viewType])}
      data-test-id='seo-content-item'
    >
      {h2Title && (
        <h2 className={s.h2Title} data-test-id='header-h2'>
          {h2Title}
        </h2>
      )}

      <HbCollapsingTextView
        className={s.textContent}
        isInitiallyCollapsed={isInitiallyCollapsed}
        isCollapsingEnabled={isCollapsingEnabled}
        buttonClassName={s.collapseButton}>
        <div className={s.textWrapper}>
          {parse(decodedContent)}
        </div>
      </HbCollapsingTextView>

      {questionsEnabled && <SeoContentQuestions questions={questions}/>}
    </section>
  )
})

function mapStateToProps(state) {
  const {
    seoState: {
      seoInfo,
      renderSeoContent
    },
  } = state;

  let seoParagraph, h2Title, seoQuestions;

  if (seoInfo) {
    h2Title = seoInfo.h2;
    seoParagraph = seoInfo.seoParagraph;
    seoQuestions = seoInfo.questions;
  } else {
    h2Title = null;
    seoParagraph = null;
    seoQuestions = null;
  }

  return {
    h2Title,
    textContent: seoParagraph,
    questions: seoQuestions,
    renderSeoContent,
  };
}

const ConnectedSeoContent = connect(mapStateToProps)(SeoContent);

export default ConnectedSeoContent;
export {
  SeoContent,
};
